export default __webpack_public_path__ + "static/media/edna.6ef4b0c8.png";